<div class="loading-spinner" *ngIf="loading">
    <app-loading></app-loading>
</div>

<div
    class="inner-container bg-white cart-page"
    *ngIf="productList?.length && !loading"
>
    <ng-container>
        <embryo-PageTitle
            *ngIf="lang == 'en'"
            heading="Here’s what’s in your Cart."
            subHeading=""
        >
        </embryo-PageTitle>
        <embryo-PageTitle
            *ngIf="lang == 'ar'"
            heading="مكونات عربة التسوق"
            subHeading=""
        >
        </embryo-PageTitle>
    </ng-container>

    <div class="container section-gap">
        <div class="cart-wrapper">
            <div class="cart-shop-list mb-5 text-center "
              [ngClass]="{'card-shadow' : !environmentVariables?.SPLIT_CART_BY_VENDOR }">
                <div class="position-relative">
                  <ng-container *ngIf="environmentVariables?.ENABLE_MULTI_VENDOR && environmentVariables?.SPLIT_CART_BY_VENDOR">
                    <div  *ngFor="let p of productList; let i = index" class="mb-4  " 
                    style="border:1px solid #ccc;border-radius: 5px">
                     <div
                         fxLayout="row wrap"
                         fxLayoutAlign="start center"
                         class="cart-item"
                         *ngFor="let product of p.items; let i = index"
                     >
                         <div
                             fxFlex.xs="100"
                             fxFlex.sm="100"
                             fxFlex.md="10"
                             fxFlex.lg="20"
                             fxFlex.xl="20"
                             class="cart-product-image"
                         >
                             <div class="cart-item-thumb">
                                 <a
                                     [routerLink]="[
                                         '/' +
                                             lang +
                                             '/products/' +
                                             product?.slug
                                     ]"
                                     class="p-link"
                                     style="cursor: pointer; outline: none"
                                 >
                                     <img
                                         width="626"
                                         height="800"
                                         onError="this.src='./assets/images/placeholder200.jpg';"
                                         default="./assets/images/placeholder200.jpg"
                                         [src]="product?.image"
                                          loading="lazy"  alt="cart image"
                                         class="product-image"
                                     />
                                 </a>
                                 <div
                                     class="chip-container d-flex flex-column"
                                     [class.chip-ar]="lang == 'ar'"
                                 >
                                     <mat-chip
                                         *ngIf="product?.preorder"
                                         class="chip-item my-1"
                                         tabindex="-1"
                                     >
                                         {{
                                             "productDetails.preorder"
                                                 | translate
                                         }}
                                     </mat-chip>
 
                                     <mat-chip
                                         *ngIf="product?.available_soon"
                                         class="chip-item my-1"
                                         tabindex="-1"
                                     >
                                         {{
                                             "productDetails.availableSoon"
                                                 | translate
                                         }}
                                     </mat-chip>
 
                                     <mat-chip
                                         *ngIf="
                                             product?.promos?.length &&
                                             product?.promos[0]
                                                 ?.show_in_product != 0
                                         "
                                         class="chip-item my-1"
                                         tabindex="-1"
                                     >
                                         {{ product?.promos[0]?.name }}
                                     </mat-chip>
 
                                     <mat-chip
                                         *ngIf="
                                             product?.promotion &&
                                             !product?.direct_discount
                                         "
                                         class="chip-item my-1"
                                         tabindex="-1"
                                     >
                                         {{ product?.promotion }}
                                     </mat-chip>
 
                                     <mat-chip
                                         *ngIf="product?.type === 2"
                                         class="chip-item my-1"
                                         tabindex="-1"
                                     >
                                         {{
                                             "productDetails.bundle" | translate
                                         }}
                                     </mat-chip>
 
                                     <mat-chip
                                         *ngIf="
                                             !product?.in_stock ||
                                             !product?.stock
                                         "
                                         class="chip-item"
                                         tabindex="-1"
                                     >
                                         {{
                                             "home_Page.outOfStouck" | translate
                                         }}
                                     </mat-chip>
                                 </div>
                             </div>
                             <button
                                 mat-raised-button
                                 color="accent"
                                 class="color-primary mt-2"
                                 (click)="moveToFav(product, i)"
                                 id="moveToFav"
                             >
                                 {{ "button.movToFav" | translate }}
                             </button>
                         </div>
                         <div
                             fxFlex.xs="100"
                             fxFlex.sm="100"
                             fxFlex.md="90"
                             fxFlex.lg="80"
                             fxFlex.xl="80"
                         >
                             <div
                                 fxLayout="row wrap"
                                 fxLayoutAlign="center center"
                                 class="cart-product-info"
                             >
                                 <a
                                     [routerLink]="[
                                         '/' +
                                             lang +
                                             '/products/' +
                                             product?.slug
                                     ]"
                                     fxFlex.xs="100"
                                     fxFlex.sm="40"
                                     fxFlex.md="30"
                                     fxFlex.lg="40"
                                     fxFlex.xl="40"
                                 >
                                     <h5
                                         style="
                                             cursor: pointer;
                                             outline: none;
                                             margin-bottom: 0px;
                                         "
                                     >
                                         {{
                                             lang === "en"
                                                 ? product?.name_en
                                                 : product?.name_ar
                                         }}
                                     </h5>
                                     <p style="margin-bottom: 0px" *ngIf="environmentVariables?. SHOW_SKU_PRODUCT_DETAILS === true || environmentVariables?. SHOW_SKU_PRODUCT_DETAILS === null">
                                         <span>
                                             {{ "receipt.sku" | translate }}:
                                         </span>
                                         <span class="sku-code">
                                             {{ product?.sku }}
                                         </span>
                                     </p>
                                     <p style="margin-bottom: 0px" *ngIf="product?.barcode &&environmentVariables?.SHOW_BARCODE_PRODUCT_DETAILS === true">
                                         <span>
                                             {{ "receipt.barcode" | translate }}:
                                         </span>
                                         <span class="sku-code">
                                             {{ product?.barcode }}
                                         </span>
                                     </p>
 
                                     <ng-container
                                         *ngIf="
                                             environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS &&
                                             product?.product_variants_options
                                                 ?.length > 0
                                         "
                                     >
                                         <p
                                             class="mb-0"
                                             *ngFor="
                                                 let options of product?.product_variants_options
                                             "
                                         >
                                             <span class="size">
                                                 {{ options?.option?.name }}:
                                                 {{ options?.values[0]?.name }}
                                             </span>
                                         </p>
                                     </ng-container>
                                     <p
                                         class="mb-0"
                                         *ngIf="
                                             product?.brand?.name &&
                                             environmentVariables?.SHOW_BRAND_ON_PRODUCT
                                         "
                                     >
                                         <span class="size">
                                             {{
                                                 "productDetails.brand"
                                                     | translate
                                             }}:
                                             {{
                                                 lang == "en"
                                                     ? product?.brand?.name
                                                     : product?.brand?.name_ar
                                             }}
                                         </span>
                                     </p>
                                 </a>
 
                                 <div
                                     fxFlex.xs="50"
                                     fxFlex.sm="20"
                                     fxLayoutAlign="center center"
                                     fxLayout="column"
                                     fxFlex.md="20"
                                     fxFlex.lg="20"
                                     fxFlex.xl="20"
                                 >
                                     <span
                                        class="w-100"
                                        [ngClass]="
                                            product?.in_stock &&
                                            product?.active &&
                                            !product?.soft_deleted
                                                ? ''
                                                : 'hidden-quantity'
                                        "
                                     >
                                         <app-control-add-to-cart
                                             (cartEmit)="cartEmit($event)"
                                             [product]="product"
                                             [styleCard]="true"
                                             [styleCartPage]="true"
                                             [source]="'details'"
                                             [isCartPage]="true"
                                             (ValidateCartStockEmit)="
                                                 ValidateCartStock($event)
                                             "
                                         >
                                         </app-control-add-to-cart>
                                     </span>
 
                                     <app-cart-stock-validation-errors
                                         [product]="product"
                                     ></app-cart-stock-validation-errors>
                                 </div>
                                 <div
                                     fxFlex.xs="50"
                                     fxFlex.sm="40"
                                     fxFlex.md="30"
                                     fxFlex.lg="20"
                                     fxFlex.xl="20"
                                 >
                                     <div
                                         *ngIf="
                                             product?.price &&
                                             environmentVariables?.GUEST_CAN_VIEW_PRICES
                                         "
                                         class="cart-item-price"
                                     >
                                         <h4
                                             style="font-size: 13px !important"
                                             class="price-value defult-price-color"
                                             [ngClass]="{
                                                 'config-price-after-discount':
                                                     product?.discount_price &&
                                                     environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                                 'config-price-color':
                                                     environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                                 'defult-price-color-after-discount':
                                                     !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                                     product?.discount_price,
                                                 'arabic-currency': lang == 'ar'
                                             }"
                                         >
                                             {{ product?.price | number }}
                                             {{
                                                 lang == "en"
                                                     ? environmentVariables?.CURRENCY_CODE_EN
                                                     : environmentVariables?.CURRENCY_CODE_AR
                                             }}
                                         </h4>
                                         <h4
                                             class="price-value payment-with-discount-container color-brand d-flex gap-5"
                                             *ngIf="
                                                 product?.discount_price !==
                                                     null &&
                                                 environmentVariables?.GUEST_CAN_VIEW_PRICES
                                             "
                                             [ngClass]="{
                                                 'config-price-before-discount':
                                                     product?.discount_price &&
                                                     environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                                 'arabic-currency': lang == 'ar'
                                             }"
                                         >
                                             {{
                                                 product?.discount_price | number
                                             }}
                                             {{
                                                 lang == "en"
                                                     ? environmentVariables?.CURRENCY_CODE_EN
                                                     : environmentVariables?.CURRENCY_CODE_AR
                                             }}
                                             <div
                                                 class="discount-method-information"
                                                 *ngIf="
                                                     product?.payment_methods_discount_name_en
                                                 "
                                             >
                                                 <p>i</p>
                                                 <div class="hover-info">
                                                     {{
                                                         lang == "en"
                                                             ? product?.payment_methods_discount_name_en
                                                             : product?.payment_methods_discount_name_ar
                                                     }}
                                                 </div>
                                             </div>
                                         </h4>
                                         <span
                                             *ngIf="
                                                 environmentVariables?.ENABLE_INCLUDING_VAT
                                             "
                                             class="inc-vat"
                                             >{{ "IncVAT" | translate }}</span
                                         >
                                         <h4
                                             class="commission-amount"
                                             *ngIf="user?.is_affiliate"
                                             [hidden]="
                                                 product.commission_amount ==
                                                     0 ||
                                                 product.commission_amount ==
                                                     null
                                             "
                                         >
                                             {{
                                                 "orders.commission" | translate
                                             }}
                                             :
                                             {{
                                                 product?.commission_amount
                                                     | number: "1.2-2"
                                             }}
                                             {{
                                                 lang == "en"
                                                     ? environmentVariables?.CURRENCY_CODE_EN
                                                     : environmentVariables?.CURRENCY_CODE_AR
                                             }}
                                         </h4>
                                     </div>
                                 </div>
                                 <div
                                     class="close-sm"
                                     fxFlex.xs="100"
                                     fxFlex.sm="100"
                                     fxFlex.md="20"
                                     fxFlex.lg="20"
                                     fxFlex.xl="20"
                                 >
                                     <div class="cart-item-price">
                                         <a
                                             href="javascript:void(0)"
                                             class="accent-color remove-cart"
                                             (click)="
                                                 !product['loading']
                                                     ? removeProduct(product, i)
                                                     : null
                                             "
                                         >
                                             <app-loading
                                                 *ngIf="product['loading']"
                                             ></app-loading>
                                             <mat-icon class="material-icons">
                                                 close
                                             </mat-icon>
                                         </a>
                                     </div>
                                 </div>
                             </div>
                         </div>
                         <ng-container *ngIf="product?.in_stock && product?.min_per_order != 0 && product?.amount <  product?.min_per_order ">
                          <div>
                            <p class="mx-3  mb-2">
                              {{"cart.Add" | translate}} {{ product.min_per_order - product?.amount }}     
                              {{"cart.More_Products_To_Make_Order" | translate}}</p>
                          </div>
                          <mat-progress-bar mode="determinate"  color="primary" [value]="calculateProgress(product)"
                          style="height: 8px;
                                  position: relative;
                                  top: 1px;"
                          ></mat-progress-bar>
                       </ng-container>
                     </div>
                     <div class="heder-vendor-cart ">
                        <div class="heder-vendor-cart__header-container">
                            <h5 class="mb-0"> {{"vendors.vendor" | translate}} : {{p?.vendor?.name_en}}</h5>
                        </div>
                       <div class="container-info-progress-bar">
                        <div class="info-progress-bar" >
                            <h4 class="mb-0">{{"cart.remaining_quantity" | translate}} : {{p?.remaining_quantity}} </h4>
                            <h4 class="mb-0" 
                            [ngStyle]="{'visibility': p?.minimum_purchase_quantity ? 'visible' : 'hidden'}"
                            >{{"cart.minimum_purchase_quantity" | translate}} : {{p?.minimum_purchase_quantity}}</h4>
                        </div>
                        <div class="info-progress-bar">
                            <h4 class="mb-0">{{"orders.total_items" | translate}} : {{getVendorItemsPrice(p.items)}} </h4>
                            <h4 class="mb-0" 
                            [ngStyle]="{'visibility': p?.minimum_purchase_amount ? 'visible' : 'hidden'}"
                            >{{"cart.minimum_purchase_amount" | translate}} : {{p?.minimum_purchase_amount}}</h4>
                        </div>
                       </div>
                     </div>
                 
                   </div>
               
                  </ng-container>
                  <ng-container *ngIf="!environmentVariables?.SPLIT_CART_BY_VENDOR">
                     <div
                         fxLayout="row wrap"
                         fxLayoutAlign="start center card-shadow"
                         class="cart-item"
                         *ngFor="let product of productList; let i = index"
                     >
                         <div
                             fxFlex.xs="100"
                             fxFlex.sm="100"
                             fxFlex.md="10"
                             fxFlex.lg="20"
                             fxFlex.xl="20"
                             class="cart-product-image"
                         >
                             <div class="cart-item-thumb">
 
                                 <a
                                     [routerLink]="[
                                         '/' +
                                             lang +
                                             '/products/' +
                                             product?.slug
                                     ]"
                                     class="p-link"
                                     style="cursor: pointer; outline: none"
                                 >
                                     <img
                                         width="626"
                                         height="800"
                                         onError="this.src='./assets/images/placeholder200.jpg';"
                                         default="./assets/images/placeholder200.jpg"
                                         [src]="product?.image"
                                          loading="lazy"  alt="cart image"
                                         class="product-image"
                                     />
                                 </a>
                                 <div
                                     class="chip-container d-flex flex-column"
                                     [class.chip-ar]="lang == 'ar'"
                                 >
                                     <mat-chip
                                         *ngIf="product?.preorder"
                                         class="chip-item my-1"
                                         tabindex="-1"
                                     >
                                         {{
                                             "productDetails.preorder"
                                                 | translate
                                         }}
                                     </mat-chip>
 
                                     <mat-chip
                                         *ngIf="product?.available_soon"
                                         class="chip-item my-1"
                                         tabindex="-1"
                                     >
                                         {{
                                             "productDetails.availableSoon"
                                                 | translate
                                         }}
                                     </mat-chip>
 
                                     <mat-chip
                                         *ngIf="
                                             product?.promos?.length &&
                                             product?.promos[0]
                                                 ?.show_in_product != 0
                                         "
                                         class="chip-item my-1"
                                         tabindex="-1"
                                     >
                                         {{ product?.promos[0]?.name }}
                                     </mat-chip>
 
                                     <mat-chip
                                         *ngIf="
                                             product?.promotion &&
                                             !product?.direct_discount
                                         "
                                         class="chip-item my-1"
                                         tabindex="-1"
                                     >
                                         {{ product?.promotion }}
                                     </mat-chip>
 
                                     <mat-chip
                                         *ngIf="product?.type === 2"
                                         class="chip-item my-1"
                                         tabindex="-1"
                                     >
                                         {{
                                             "productDetails.bundle" | translate
                                         }}
                                     </mat-chip>
 
                                     <mat-chip
                                         *ngIf="
                                             !product?.in_stock ||
                                             !product?.stock
                                         "
                                         class="chip-item"
                                         tabindex="-1"
                                     >
                                         {{
                                             "home_Page.outOfStouck" | translate
                                         }}
                                     </mat-chip>
                                 </div>
                             </div>
                             <button
                                 mat-raised-button
                                 color="accent"
                                 class="color-primary mt-2"
                                 (click)="moveToFav(product, i)"
                                 id="moveToFav"
                             >
                                 {{ "button.movToFav" | translate }}
                             </button>
                         </div>
                         <div
                             fxFlex.xs="100"
                             fxFlex.sm="100"
                             fxFlex.md="90"
                             fxFlex.lg="80"
                             fxFlex.xl="80"
                         >
                             <div
                                 fxLayout="row wrap"
                                 fxLayoutAlign="center center"
                                 class="cart-product-info"
                             >
                                 <a
                                     [routerLink]="[
                                         '/' +
                                             lang +
                                             '/products/' +
                                             product?.slug
                                     ]"
                                     fxFlex.xs="100"
                                     fxFlex.sm="40"
                                     fxFlex.md="30"
                                     fxFlex.lg="40"
                                     fxFlex.xl="40"
                                 >
                                     <h5
                                         style="
                                             cursor: pointer;
                                             outline: none;
                                             margin-bottom: 0px;
                                         "
                                     >
                                         {{
                                             lang === "en"
                                                 ? product?.name_en
                                                 : product?.name_ar
                                         }}
                                     </h5>
                                     <p style="margin-bottom: 0px" *ngIf="environmentVariables?. SHOW_SKU_PRODUCT_DETAILS === true || environmentVariables?. SHOW_SKU_PRODUCT_DETAILS === null">
                                         <span>
                                             {{ "receipt.sku" | translate }}:
                                         </span>
                                         <span class="sku-code">
                                             {{ product?.sku }}
                                         </span>
                                     </p>
                                     <p style="margin-bottom: 0px" *ngIf="product?.barcode &&environmentVariables?.SHOW_BARCODE_PRODUCT_DETAILS === true">
                                         <span>
                                             {{ "receipt.barcode" | translate }}:
                                         </span>
                                         <span class="sku-code">
                                             {{ product?.barcode }}
                                         </span>
                                     </p>
 
                                     <ng-container
                                         *ngIf="
                                             environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS &&
                                             product?.product_variants_options
                                                 ?.length > 0
                                         "
                                     >
                                         <p
                                             class="mb-0"
                                             *ngFor="
                                                 let options of product?.product_variants_options
                                             "
                                         >
                                             <span class="size">
                                                 {{ options?.option?.name }}:
                                                 {{ options?.values[0]?.name }}
                                             </span>
                                         </p>
                                     </ng-container>
                                     <p
                                         class="mb-0"
                                         *ngIf="
                                             product?.brand?.name &&
                                             environmentVariables?.SHOW_BRAND_ON_PRODUCT
                                         "
                                     >
                                         <span class="size">
                                             {{
                                                 "productDetails.brand"
                                                     | translate
                                             }}:
                                             {{
                                                 lang == "en"
                                                     ? product?.brand?.name
                                                     : product?.brand?.name_ar
                                             }}
                                         </span>
                                     </p>
                                 </a>
 
                                 <div
                                     fxFlex.xs="50"
                                     fxFlex.sm="20"
                                     fxLayoutAlign="center center"
                                     fxLayout="column"
                                     fxFlex.md="20"
                                     fxFlex.lg="20"
                                     fxFlex.xl="20"
                                 >
                                     <span
                                        class="w-100"
                                         [ngClass]="
                                             product?.in_stock &&
                                             product?.active &&
                                             !product?.soft_deleted
                                                 ? ''
                                                 : 'hidden-quantity'
                                         "
                                     >
                                         <app-control-add-to-cart
                                             (cartEmit)="cartEmit($event)"
                                             [product]="product"
                                             [styleCard]="true"
                                             [styleCartPage]="true"
                                             [source]="'details'"
                                             [isCartPage]="true"
                                             (ValidateCartStockEmit)="
                                                 ValidateCartStock($event)
                                             "
                                         >
                                         </app-control-add-to-cart>
                                     </span>
 
                                     <app-cart-stock-validation-errors
                                         [product]="product"
                                     ></app-cart-stock-validation-errors>
                                 </div>
                                 <div
                                     fxFlex.xs="50"
                                     fxFlex.sm="40"
                                     fxFlex.md="30"
                                     fxFlex.lg="20"
                                     fxFlex.xl="20"
                                 >
                                     <div
                                         *ngIf="
                                             product?.price &&
                                             environmentVariables?.GUEST_CAN_VIEW_PRICES
                                         "
                                         class="cart-item-price"
                                     >
                                         <h4
                                             style="font-size: 13px !important"
                                             class="price-value defult-price-color"
                                             [ngClass]="{
                                                 'config-price-after-discount':
                                                     product?.discount_price &&
                                                     environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                                 'config-price-color':
                                                     environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                                 'defult-price-color-after-discount':
                                                     !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                                     product?.discount_price,
                                                 'arabic-currency': lang == 'ar'
                                             }"
                                         >
                                             {{ product?.price | number }}
                                             {{
                                                 lang == "en"
                                                     ? environmentVariables?.CURRENCY_CODE_EN
                                                     : environmentVariables?.CURRENCY_CODE_AR
                                             }}
                                         </h4>
                                         <h4
                                             class="price-value payment-with-discount-container color-brand d-flex gap-5"
                                             *ngIf="
                                                 product?.discount_price !==
                                                     null &&
                                                 environmentVariables?.GUEST_CAN_VIEW_PRICES
                                             "
                                             [ngClass]="{
                                                 'config-price-before-discount':
                                                     product?.discount_price &&
                                                     environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                                 'arabic-currency': lang == 'ar'
                                             }"
                                         >
                                             {{
                                                 product?.discount_price | number
                                             }}
                                             {{
                                                 lang == "en"
                                                     ? environmentVariables?.CURRENCY_CODE_EN
                                                     : environmentVariables?.CURRENCY_CODE_AR
                                             }}
                                             <div
                                                 class="discount-method-information"
                                                 *ngIf="
                                                     product?.payment_methods_discount_name_en
                                                 "
                                             >
                                                 <p>i</p>
                                                 <div class="hover-info">
                                                     {{
                                                         lang == "en"
                                                             ? product?.payment_methods_discount_name_en
                                                             : product?.payment_methods_discount_name_ar
                                                     }}
                                                 </div>
                                             </div>
                                         </h4>
                                         <span
                                             *ngIf="
                                                 environmentVariables?.ENABLE_INCLUDING_VAT
                                             "
                                             class="inc-vat"
                                             >{{ "IncVAT" | translate }}</span
                                         >
                                         <h4
                                             class="commission-amount"
                                             *ngIf="user?.is_affiliate"
                                             [hidden]="
                                                 product.commission_amount ==
                                                     0 ||
                                                 product.commission_amount ==
                                                     null
                                             "
                                         >
                                             {{
                                                 "orders.commission" | translate
                                             }}
                                             :
                                             {{
                                                 product?.commission_amount
                                                     | number: "1.2-2"
                                             }}
                                             {{
                                                 lang == "en"
                                                     ? environmentVariables?.CURRENCY_CODE_EN
                                                     : environmentVariables?.CURRENCY_CODE_AR
                                             }}
                                         </h4>
                                     </div>
                                 </div>
                                 <div
                                     class="close-sm"
                                     fxFlex.xs="100"
                                     fxFlex.sm="100"
                                     fxFlex.md="20"
                                     fxFlex.lg="20"
                                     fxFlex.xl="20"
                                 >
                                     <div class="cart-item-price">
                                         <a
                                             href="javascript:void(0)"
                                             class="accent-color remove-cart"
                                             (click)="
                                                 !product['loading']
                                                     ? removeProduct(product, i)
                                                     : null
                                             "
                                         >
                                             <app-loading
                                                 *ngIf="product['loading']"
                                             ></app-loading>
                                             <mat-icon class="material-icons">
                                                 close
                                             </mat-icon>
                                         </a>
                                     </div>
                                 </div>
                             </div>
                         </div>
                         <ng-container *ngIf="product?.in_stock && product?.min_per_order != 0 && product?.amount <  product?.min_per_order ">
                            <div>
                              <p class="mx-3">
                                {{"cart.Add" | translate}} {{ product.min_per_order - product?.amount }}     
                                {{"cart.More_Products_To_Make_Order" | translate}}</p>
                            </div>
                            <mat-progress-bar mode="determinate"  color="primary" [value]="calculateProgress(product)"
                            style="height: 8px;
                                    position: relative;
                                    top: 1px;"
                            ></mat-progress-bar>
                         </ng-container>
                        
                     </div>
                
                  </ng-container>


                
                </div>
            </div>

            <ng-container *ngIf="suggestions">
                <div class="container p-0">
                    <div class="cart-wrapper">
                        <div class="cart-shop-list mb-5 card-shadow">
                            <div
                                class="position-relative p-3"
                                *ngFor="let suggestion of suggestions"
                            >
                                <h6>{{ lang == 'en' ?  suggestion?.promotion_name : suggestion?.promotion_name_ar
                                }}</h6>
                                <div class="row">
                                    <mat-form-field appearance="outline" style="direction: initial;">
                                        <mat-select
                                            placeholder="{{
                                              lang == 'en' ?  suggestion?.promotion_name : suggestion?.promotion_name_ar
                                            }}"
                                        >
                                            <mat-option
                                                *ngFor="
                                                    let item of suggestion?.products
                                                "
                                                [value]="item.id"
                                                (click)="addProductToCart(item)"
                                            >
                                                {{ lang == 'en' ?  item.name : item.name_ar }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <a
                                        class="mr-2 ml-2"
                                        [routerLink]="[
                                            '/' + lang + '/products'
                                        ]"
                                        [queryParams]="{
                                            list_ids: suggestion.list_id
                                        }"
                                        *ngIf="suggestion?.list_count > 10"
                                        >You can show more
                                        {{ suggestion?.list_name }}</a
                                    >

                                </div>

                            </div>


                        </div>
                    </div>
                </div>
            </ng-container>
						

            <!-- gift section -->
            <div class="gift-container"
                *ngIf="gifts.length > 0">
                <div class="d-flex flex-column justify-center h-100 pl-4">
                    <div class="text-white">
                        <span class="fs-sm-14">{{ "cart.youGot" | translate }}</span>
                        <span class="fs-sm-14" *ngFor="let gift of gifts; let i = index">
                            <ng-container *ngIf="i !== 0">,</ng-container> 
                            <span [dir]="lang == 'en' ? 'ltr' : 'rtl'"> {{ gift.count }} {{ gift.name }} </span>
                        </span>							
                    </div>
                </div>
            </div>

            <div
                class="cart-total mt-3"
                fxLayout="row wrap"
                fxLayoutAlign="flex-end"
            >
                <div
                    fxFlex.xs="100"
                    fxFlex.sm="100"
                    fxFlex.md="40"
                    fxFlex.lg="40"
                    fxFlex.xl="40"
                >
                    <div class="mb-4 mx-2">
                        <h4>{{ "orders.total" | translate }}</h4>
                        <span fxFlex></span>
                        <h4
                            *ngIf="environmentVariables?.GUEST_CAN_VIEW_PRICES"
                            class="font-w-bold brand-color"
                            [ngClass]="{
                                'price-color':
                                    environmentVariables?.PRODUCT_PRICE_TEXT_COLOR
                            }"
                        >
                            {{ getTotalPrice()  | number: "1.2-2"}}
                            {{
                                lang == "en"
                                    ? environmentVariables?.CURRENCY_CODE_EN
                                    : environmentVariables?.CURRENCY_CODE_AR
                            }}
                        </h4>
                    </div>
                    <div class="mb-4 mx-2" *ngIf="cashBack?.amount">
                        <h4>{{ "cashBack.cashBack" | translate }}</h4>
                        <span fxFlex></span>
                        <h4
                            class="font-w-bold brand-color"
                            [ngClass]="{
                                'price-color':
                                    environmentVariables?.PRODUCT_PRICE_TEXT_COLOR
                            }"
                        >
                            {{ cashBack?.amount  | number: "1.2-2"}}
                            {{
                                lang == "en"
                                    ? environmentVariables?.CURRENCY_CODE_EN
                                    : environmentVariables?.CURRENCY_CODE_AR
                            }}
                        </h4>
                    </div>
                    <div
                        class="mb-4 "
                        *ngIf="
                            user?.is_affiliate &&
                            calculateTotalCommission() != 0 &&
                            calculateTotalCommission() != null
                        "
                    >
                        <h4>{{ "orders.TotalCommission" | translate }}</h4>
                        <span fxFlex></span>
                        <h4>
                            {{ calculateTotalCommission() | number }}
                            {{
                                lang == "en"
                                    ? environmentVariables?.CURRENCY_CODE_EN
                                    : environmentVariables?.CURRENCY_CODE_AR
                            }}
                        </h4>
                    </div>
                    <div class="purshase-buttons">
                        <button
                            mat-raised-button
                            class="button-lg color-outline-primary min-w200px mx-2"
                            [routerLink]="['/' + lang + '/']"
                        >
                            {{ "button.AddMoreProducts" | translate }}
                        </button>
                        <button
                            mat-raised-button
                            color="accent"
                            [ngClass]="{'disabled' : disabledCheckout  || disabledCheckoutBtn}"
                            class="button-lg color-primary min-w200px mx-2"
                            (click)="updateLocalCartProduct()"
                            [disabled]="disabled_button_checkout"
                            id="goToCheckout"
                        >
                            {{ "button.buttonCheckout" | translate }}
                        </button>
                   
                    
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="!productList?.length && !loading">
    <div class="section-gap-lg text-center cartEmpty">
        <div class="mb-4">
            <svg
                id="svg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="400"
                height="400"
                viewBox="0, 0, 400,400"
            >
                <g id="svgg">
                    <path
                        id="path0"
                        d="M0.000 39.063 L 0.000 56.250 25.000 56.250 C 38.750 56.250,50.068 57.305,50.151 58.594 C 50.235 59.883,59.793 108.047,71.393 165.625 L 92.483 270.313 217.769 271.129 C 316.276 271.771,343.397 271.103,344.657 268.004 C 364.714 218.673,399.920 123.057,398.948 120.551 C 398.231 118.701,391.248 114.833,383.431 111.955 L 369.217 106.722 356.928 138.517 C 350.169 156.005,339.166 184.741,332.476 202.377 L 320.313 234.441 220.460 233.627 L 120.607 232.813 99.518 128.125 C 87.918 70.547,78.360 23.086,78.276 22.656 C 78.193 22.227,60.547 21.875,39.063 21.875 L 0.000 21.875 0.000 39.063 M194.469 34.735 C 164.180 49.728,148.185 82.523,150.623 124.636 C 156.840 232.037,293.160 232.037,299.377 124.636 C 303.407 55.024,248.513 7.984,194.469 34.735 M242.672 72.277 C 256.620 83.853,262.850 125.642,253.327 143.750 C 227.478 192.905,178.167 152.809,194.062 95.559 C 201.223 69.765,225.586 58.097,242.672 72.277 M129.378 284.079 C 110.433 292.683,101.563 306.905,101.563 328.677 C 101.563 383.363,175.860 396.683,195.407 345.501 C 211.302 303.880,170.124 265.575,129.378 284.079 M270.313 282.384 C 232.471 299.962,229.920 351.964,265.954 371.261 C 298.655 388.773,337.500 365.353,337.500 328.125 C 337.500 293.983,300.122 268.537,270.313 282.384 "
                        stroke="none"
                        fill-rule="evenodd"
                    ></path>
                </g>
            </svg>
        </div>
        <h4>{{ "checkout.cartEmpty" | translate }}</h4>
        <a
            href="javascript:void(0)"
            class="primary-color"
            [routerLink]="['/' + lang + '/']"
        >
            {{ "cart.goForShopping" | translate }}
        </a>
    </div>
</ng-container>
